import personGraphic from '../../assets/peopleFull.png';
import React, { Component } from "react";


export default class ShopListItemQueueGraphic extends Component {
    render() {
        return(
            <img src={personGraphic} width='6%' />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_list_item/shop_list_item_queue_graphic.jsx